import type { FC, ReactNode } from 'react'

import { Waves } from 'lucide-react'
import { siteConfig } from '@/constants/site'

interface SiteFooterProps {
    text: string | null
}

const SiteFooter: FC<SiteFooterProps> = ({ text }): ReactNode => {
    return (
        <footer className='border-t px-6 py-10'>
            <div className='mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 text-sm text-muted-foreground sm:flex-row'>
                <p className='inline-flex items-center gap-2 font-heading text-lg text-foreground'>
                    <Waves aria-hidden='true' className='size-5 text-primary' />
                    {siteConfig.name}
                </p>

                {text && <p className='text-center sm:text-right'>{text}</p>}
            </div>
        </footer>
    )
}

export default SiteFooter
